import { cn } from '@/lib/cn';
import { fmt, texts } from '@/lib/texts';

export interface StepperProps {
  /** Текущий шаг, с 1 */
  current: number;
  total: number;
  /** Подписи шагов — показывается только текущая */
  labels?: readonly string[];
  className?: string;
}

/** Прогресс онбординга: полоски по числу шагов и подпись «Шаг 2 из 5 · Район». */
export function Stepper({ current, total, labels, className }: StepperProps) {
  const label = labels?.[current - 1];
  return (
    <div
      className={cn('flex flex-col gap-2', className)}
      aria-label={fmt(texts.stepper.step, { current, total })}
    >
      <div
        className="flex gap-1.5"
        role="progressbar"
        aria-valuemin={1}
        aria-valuemax={total}
        aria-valuenow={current}
      >
        {Array.from({ length: total }, (_, i) => (
          <span
            key={i}
            className={cn(
              'h-1 flex-1 rounded-full transition-colors',
              i < current ? 'bg-accent' : 'bg-surface-2',
            )}
          />
        ))}
      </div>
      <div className="text-muted text-xs font-medium">
        {fmt(texts.stepper.step, { current, total })}
        {label ? ` · ${label}` : ''}
      </div>
    </div>
  );
}
